// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-r-6px[data-v-5312a259] {\n  margin-right: 6px;\n}", ""]);
// Exports
module.exports = exports;
